module.exports = __webpack_public_path__ + "static/media/pusins_dick.b75a4b14.jpg";